<script>
  export default {
    name: 'GoBackButton',
    methods: {
      goBack () {
        window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/')
      }
    }
  }
</script>

<template>
  <div class="go-back">
    <button class="go-back__button" @click="goBack">
      <img class="go-back__icon" src="@/assets/svg/icon-chevron-left.svg" alt="Voltar" />
      <span>Voltar</span>
    </button>
  </div>
</template>

<style lang="scss" scoped>
  .go-back {
    width: 100%;
    height: 24px;
    margin: 12px 0 24px;
    color: #636D7A;

    &__button {
      display: flex;
      align-items: center;
      font-weight: bold;
    }

    &__icon {
      width: 8px;
      height: 14px;
      margin-right: 16px;
    }
  }
</style>
